import { useEffect, useState } from 'react';

import { toTextSetting } from '../tiptap/nodes/templateField/fieldSettings';

/** Holds the typed text: a card's node view hands it back a microtask late, after React has reset the input. */
const useTypedSetting = (fieldId: string, setting: string | null) => {
  const [typed, setTyped] = useState(setting ?? '');

  useEffect(() => setTyped((current) => (toTextSetting(current) === setting ? current : (setting ?? ''))), [setting]);
  useEffect(() => setTyped(setting ?? ''), [fieldId]);

  return [typed, setTyped] as const;
};

export default useTypedSetting;
